import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { CURRENT_STATE_PROJECT_KEY, Linqset, LinqsetEdge, NODE_TYPE } from "../common/linqset-model";
import { Organisation, TagGroup } from "../common/organisation";
import { LineData } from "../charts/line-chart/line-chart.component";
import { AnalyticsData, AnalyticsService } from "../model-services/analytics-service";
import { ExceptionAndLoggingService } from "../linq-utils/logging/exception-logging-service";
import { GraphProcessingService } from "../model-services/graph-processing.service";
import { Subscription } from "rxjs";
import { LinqsetRepositoryService } from "../model-services/linqset-repository.service";
import { AppComponent } from "../app.component";
import { GraphService } from "../canvas/graph.service";
import { GraphComponent, IModelItem } from "@yfiles/yfiles";

const COMPONENT = "Insights component"

@Component({
    selector: 'app-insights',
    templateUrl: './insights.html',
    styleUrls: ['./insights.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InsightsComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() organisation:Organisation
    @Input() linqset:Linqset
    @Input() comparison:Linqset
    @Input() selectedTagGroup:TagGroup
    @Input() graphComponent:GraphComponent
    @Input() isGrouped:boolean          // whether model has been grouped or not

    @Output() selectItemsEvent = new EventEmitter<string[]>()

    processingSubscription:Subscription
    refreshTrigger:any
    analyticsData:AnalyticsData
    lineData:LineData

    constructor(private exceptionService:ExceptionAndLoggingService, public repoService:LinqsetRepositoryService, private graphService:GraphService,
        private analyticsService:AnalyticsService, private processingService:GraphProcessingService) {}

    ngAfterViewInit(): void {
        if (!this.processingSubscription) {
            this.processingSubscription = this.processingService.processCompletedEvent.subscribe(async e => {
                this.refreshTrigger = {}
            })
        }
    }

    ngOnDestroy(): void {
        if (this.processingSubscription) this.processingSubscription.unsubscribe()
    }
   
    async ngOnChanges(changes: SimpleChanges) {
        if (this.linqset && changes["linqset"]) {
            this.refreshData()
        }
    }

    isProject() {return this.linqset && this.linqset.workspaceKey !== CURRENT_STATE_PROJECT_KEY}
    isOrganisation() {return this.linqset && this.linqset.isOrganisationModel()}

    isHelpOn() {
        return AppComponent.help
    }
    
    async refreshData() {
        if (!this.linqset.isTutorial()) {
            try {
                this.loadAnalyticsData()
            }catch (err) {
                this.exceptionService.handleCaughtError(err, COMPONENT, "Refresh data", "Error while creating node data. Missing insights.")
            }
        }
        this.refreshTrigger = {}
    }

    getProject() {
        return !this.linqset.isCurrentState() && this.organisation.projects.find(p => p._key === this.linqset.workspaceKey)
    }

    selectNodes(keys:string[]) {
        this.selectItemsEvent.emit(keys)
    }

    selectEdges(edges:LinqsetEdge[]) {
        this.graphService.selectModelItems(this.graphComponent, edges.map(n => this.graphComponent.graph.edges.find(ge => ge.tag && ge.tag.edge._key === n._key)))
    }

    selectModelItems(items:IModelItem[]) {
        this.graphService.selectModelItems(this.graphComponent, items)
    }

    async loadAnalyticsData() {
        this.analyticsData = await this.analyticsService.loadAnalyticsData(this.organisation._key, this.linqset.workspaceKey, this.linqset.modelKey)
        this.lineData = this.analyticsData && this.analyticsService.loadAnalyticsDataForChart(this.analyticsData.analytics).changes
    }
}